module.exports = __webpack_public_path__ + "img/Veselin.5326c9c7.png";